import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UserStatus } from '@freelancer/datastore/collections';
import { ModalService } from '@freelancer/ui';
import { IconColor } from '@freelancer/ui/icon';

@Component({
  selector: 'app-user-profile-summary-verifications',
  template: `
    <fl-bit
      class="ProfileVerifications"
      flTrackingLabel="ProfileVerifications"
      (click)="openModal()"
    >
      <fl-icon
        [name]="'ui-user'"
        [color]="status.identityVerified ? IconColor.SUCCESS : IconColor.MID"
      ></fl-icon>
      <fl-icon
        [name]="'ui-payment-verified'"
        [color]="status.paymentVerified ? IconColor.SUCCESS : IconColor.MID"
      ></fl-icon>
      <fl-icon
        [name]="'ui-phone'"
        [color]="status.phoneVerified ? IconColor.SUCCESS : IconColor.MID"
      ></fl-icon>
      <fl-icon
        [name]="'ui-mail'"
        [color]="status.emailVerified ? IconColor.SUCCESS : IconColor.MID"
      ></fl-icon>
      <fl-icon
        [name]="'ui-facebook'"
        [color]="status.facebookConnected ? IconColor.SUCCESS : IconColor.MID"
      ></fl-icon>
    </fl-bit>
  `,
  styleUrls: ['./user-profile-summary-verifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileSummaryVerificationsComponent {
  IconColor = IconColor;

  @Input() status: UserStatus;

  constructor(private modalService: ModalService) {}

  openModal() {
    this.modalService.open('ProfileVerificationsModal', {
      inputs: {
        status: this.status,
      },
      closeable: false,
      edgeToEdge: true,
    });
  }
}
